module.exports = __webpack_public_path__ + "static/media/af.14c45ecc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/af.svg
// module id = 1171
// module chunks = 0